export default "<div class=\"wrapper\">\n  <app-header></app-header>\n  <app-sidebar></app-sidebar>\n  <app-content></app-content>\n</div>\n\n\n"